export const EXERCISE_TYPES = {
  MACHINE: "MACHINE",
  GRAMMAR: "GRAMMAR",
  REGULAR_EXPRESSIONS: "REGULAR_EXPRESSIONS",
};
